'use client';

import { useClientTranslation } from '@lib/i18n/client';
import { EVENT_PHASER_OPENER } from '@modules/phaser/config';
import { useThirdPartyEvent } from '@tuic/lib/src/hooks';
import { TextButton } from '@tuic/web-compositions/core/TextButton';

import { usePhaser } from '../lib/phaser-context';

import type { FC } from 'react';

export const PhaserButton: FC = () => {
  const { t } = useClientTranslation();
  const { invoke: openPhaser } = useThirdPartyEvent(EVENT_PHASER_OPENER);
  const phaser = usePhaser();

  if (!phaser?.render) {
    return null;
  }

  return (
    <div className="text-center">
      <TextButton onClick={() => openPhaser()}>
        {t('Debug-Tool öffnen')}
      </TextButton>
    </div>
  );
};
